import React from 'react'
import PropType from 'prop-types'
import SelectField from '../../components/SelectField/SelectField'
import './PhoneNumber.scss'
import isBetweenRange from '../../helpers/isBetweenRange'
class PhoneNumber extends React.Component {
  state = {
    countryCode: '',
    label: '',
    placeholder: '',
    phoneNumber: '',
    range: '',
  }

  componentDidUpdate = prevProps => {
    const { defaultCountry } = this.props
    const { defaultCountry: oldDefaultCountry } = prevProps
    if (defaultCountry !== oldDefaultCountry) {
      this.setSelectedCountry(defaultCountry)
    }
  }

  componentDidMount = () => {
    const { phoneNumber, countryName } = this.props
    if (phoneNumber && countryName) {
      this.setState({
        label: countryName,
      })
    } else {
      this.setSelectedCountry(this.props.defaultCountry)
    }
  }

  setSelectedCountry = defaultCountry => {
    const { phoneNumber, countryCode } = this.props
    // if defaultCountry is retrieved and countryCode is not filled in, use default country
    if (defaultCountry && !countryCode && !phoneNumber) {
      this.handleCountryChange(defaultCountry)
    }
    // if phonenumber and countrycode are already provided, fill state
    if (phoneNumber && countryCode) {
      this.setState({
        phoneNumber,
        countryCode,
      })
    }
  }

  handleCountryCodeChange = e => {
    new RegExp(/^([+\d]*)$/).test(e.target.value) &&
      this.setState({ countryCode: e.target.value })
  }
  sanitizeCountryCode = () => {
    const { countryCode: input } = this.state
    const { countryList } = this.props
    let countryCode = input.replace(/[^0-9]+/g, '')
    if (countryCode.indexOf('00') === 0) {
      countryCode = countryCode.replace('00', '+')
    } else if (!countryCode.match(/'+'/) && countryCode.length > 0) {
      countryCode = `+${countryCode}`
    }
    const matchedCountry = countryList.find(x => x.countryCode === countryCode)
    const otherCountry = countryList.find(x => x.countryCode === '')
    matchedCountry
      ? this.handleCountryChange(matchedCountry)
      : this.handleCountryChange({ ...otherCountry, countryCode })
  }
  handleCountryChange = (country = {}) => {
    this.phoneNumberInput.focus()
    this.validatePhoneNumber(this.state.phoneNumber, country)
    this.setState({
      ...country,
    })
  }

  validatePhoneNumber = (number, country) => {
    const { label, countryCode, range } = country
    if (number.length > 0) {
      if (isBetweenRange(number, range)) {
        this.props.handleChange({
          countryName: label,
          phoneNumber: number,
          countryCode,
          range,
        })
      } else {
        this.props.handleChange({
          countryName: '',
          phoneNumber: '',
          countryCode: '',
          range: '',
        })
      }
    }
  }

  updatePhoneNumber = e => {
    const country = { ...this.state }
    this.setState({ phoneNumber: e.target.value })
    this.validatePhoneNumber(e.target.value, country)
  }

  render() {
    const {
      fieldLabel,
      countryList,
      autoFillName,
      autoCompleteName,
      errorMessage,
      isValid,
    } = this.props
    const { countryCode, placeholder, phoneNumber, label } = this.state
    const isInvalid = isValid === false
    return (
      <div className="PhoneNumber">
        <p className="Field__label">{fieldLabel}</p>
        <SelectField
          selectedItem={{ label }}
          placeholder="Choose a country"
          options={countryList}
          handleChange={this.handleCountryChange}
        />
        <input
          className="PhoneNumber__country-code-field"
          value={countryCode || ''}
          placeholder="+00"
          onChange={this.handleCountryCodeChange}
          onBlur={this.sanitizeCountryCode}
          maxLength="5"
          type="text"
        />
        <input
          className={`PhoneNumber__field ${isInvalid ? 'invalid' : ''}`}
          placeholder={placeholder}
          value={phoneNumber || ''}
          onChange={this.updatePhoneNumber}
          type="number"
          ref={el => (this.phoneNumberInput = el)}
          name={autoFillName}
          autoComplete={autoCompleteName}
        />
        {isInvalid && (
          <p className="PhoneNumber__error-message">{errorMessage}</p>
        )}
      </div>
    )
  }
}
PhoneNumber.propTypes = {
  errorMessage: PropType.string,
  fieldLabel: PropType.string.isRequired,
  handleChange: PropType.func.isRequired,
  countryList: PropType.array,
  phoneNumber: PropType.string,
  autoFillName: PropType.string,
  autoCompleteName: PropType.string,
  countryCode: PropType.string,
  countryName: PropType.string,
  range: PropType.string,
  defaultCountry: PropType.object,
  isValid: PropType.bool,
}

export default PhoneNumber
